import * as React from 'react';
import styled from 'styled-components';

interface Props {
  text?: string;
  color?: string;
  darkText?: boolean;
}

const Badge = ({ text = 'BADGE', color = null, darkText = false }: Props) => (
  <BadgeWrapper data-testid="badge-wrapper" $backgroundColor={color}>
    <BadgeText data-testid="badge-text" hasDarkColor={darkText}>
      {text}
    </BadgeText>
  </BadgeWrapper>
);

export default Badge;

const BadgeWrapper = styled.div<{ $backgroundColor: string | null }>`
  border-radius: 3px;
  padding: 0px 5px;
  display: inline-block;
  background-color: ${(props) => props.$backgroundColor || '#0751C2'};
`;

const BadgeText = styled.span<{ hasDarkColor: boolean }>`
  font-weight: bold;
  font-size: 10px;
  color: ${(props) => (props.hasDarkColor ? '#17233C' : '#ffffff')};
  text-transform: uppercase;
  text-align: center;
  display: flex;
  align-items: center;
  padding: 2px 0 1px 0;
`;
